"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const sale = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-sale` : '') + (description ? ` desc-sale` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-sale"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-sale"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.25 3.59a2.34 2.34 0 0 1 2.34-2.34h6.5l.22.01c.54.06 1.04.3 1.43.68l10.33 10.32.15.18a2.34 2.34 0 0 1-.15 3.13l-6.5 6.5a2.34 2.34 0 0 1-3.3 0L1.92 11.73a2.34 2.34 0 0 1-.68-1.66v-6.5Zm1.5 6.5v.07a.84.84 0 0 0 .25.51L13.33 21a.84.84 0 0 0 1.18 0l6.5-6.49a.84.84 0 0 0 0-1.19L10.66 3a.84.84 0 0 0-.5-.25H3.57a.84.84 0 0 0-.83.84v6.5Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.38 6.56a.38.38 0 0 1-.38.38v.74a1.13 1.13 0 0 1-.8-1.92l.09-.07c.2-.16.45-.26.71-.26v.75c.07 0 .15.03.2.07l.07.04.04.06a.4.4 0 0 1 .07.21Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.13 6.56A1.13 1.13 0 0 1 7 7.69v-.76a.38.38 0 0 1-.27-.64l.06-.04A.37.37 0 0 1 7 6.18v-.75c.26 0 .51.1.71.26l.09.07.07.09c.16.2.25.45.25.71Z",
    fill: "#232323"
  }));
};
var _default = exports.default = sale;